/*
 * @Description:
 * @Date: 2024-01-11 14:07:18
 */

const views = (require as any).context(
  './',
  true,
  /pc-module-overview-\d+\.vue/
);

export default views.keys().map(path => {
  return views(path).default;
});

export const _testOverviewData = {
  aspName: '服务商：天津九如医疗科技有限公司',
  dataSum: 100,
  deletes: [],
  demandDesc: '终端拜访-零售药店巡店',
  demandLocation: '青海省',
  demandName: '关于双鲸维生素E胶囊(天然型)产品在青海地区的零售药店巡店项目',
  executeTime: '2021-08-01 - 2022-07-31',
  gongyeName: '项目方：青岛双鲸药业股份有限公司',
  isDelete: 0,
  isHave: 1,
  isShowUserSum: 1,
  price: '300W以上',
  projectType: 20,
  submitTime: '2023-08-16',
  title: '项目总览',
  userSum: 2
};

const svg = {
  price: `
  <svg xmlns="http://www.w3.org/2000/svg" width="20.597" height="20.596" viewBox="0 0 20.597 20.596">
    <path  d="M116.965,106.667a10.3,10.3,0,1,0,10.3,10.3A10.3,10.3,0,0,0,116.965,106.667Zm3.431,12.358a1.03,1.03,0,0,1,0,2.06h-2.4v1.371a1.03,1.03,0,0,1-2.06,0v-1.371h-2.4a1.03,1.03,0,0,1,0-2.06h2.4v-1.718h-2.4a1.03,1.03,0,0,1,0-2.06h1.957l-2.672-2.672a1.03,1.03,0,0,1,1.436-1.453l2.71,2.71,2.645-2.645a1,1,0,1,1,1.415,1.415l-2.661,2.661h2.022a1.03,1.03,0,0,1,0,2.06h-2.39v1.7Z" transform="translate(-106.667 -106.667)" fill="var(--theme-color-1)"/>
  </svg>`,
  asp: `
  <svg xmlns="http://www.w3.org/2000/svg" width="18.569" height="18.275" viewBox="0 0 18.569 18.275">
    <g transform="translate(0 0)">
      <ellipse cx="5.077" cy="5.077" rx="5.077" ry="5.077" transform="translate(4.159)" fill="var(--theme-color-1)" style="isolation: isolate"/>
      <path d="M1115.81,1936.96a7.626,7.626,0,0,1,5.458-2.949.217.217,0,0,1,.18.066l2.864,3.019a.06.06,0,0,0,.1-.043l-.048-1.552a.693.693,0,0,1,.511-.694l.026-.006a.69.69,0,0,1,.826.686v1.635a.06.06,0,0,0,.1.041l2.857-3.134a.209.209,0,0,1,.206-.063c.747.185,4.721,1.236,5.366,2.845a.232.232,0,0,1,.015.084v3.919a.2.2,0,0,1-.01.065c-.055.162-.34.889-1.038.918h-16.425a.182.182,0,0,1-.033,0,1.325,1.325,0,0,1-1.054-.946.255.255,0,0,1-.009-.069l.064-3.7A.207.207,0,0,1,1115.81,1936.96Z" transform="translate(-1115.71 -1923.519)" fill="var(--theme-color-1)"/>
    </g>
  </svg>`,
  dataSum: `
  <svg xmlns="http://www.w3.org/2000/svg" width="19.255" height="18.566" viewBox="0 0 19.255 18.566">
    <path d="M66,98.559q.382-.477.765-.889a8.319,8.319,0,0,1,.627-.694q.33-.325.5-.477a3.442,3.442,0,0,1,.5-.347A1.422,1.422,0,0,1,69.1,96h9.18a2.034,2.034,0,0,1,.637.12,1.674,1.674,0,0,1,.7.488c.113.144.261.325.447.542s.36.426.529.629c.2.247.4.507.595.781Zm17.255,6.484a1.588,1.588,0,0,1-1.723,1.648h-15.7a1.739,1.739,0,0,1-1.286-.477,1.594,1.594,0,0,1-.477-1.171v-3.1a1.783,1.783,0,0,1,.425-1.192,1.713,1.713,0,0,1,1.381-.5h15.64a1.616,1.616,0,0,1,1.359.5,1.893,1.893,0,0,1,.384,1.194v3.1Zm-8.012-1.561a.51.51,0,0,0-.138-.4.549.549,0,0,0-.373-.118H72.586a.513.513,0,0,0-.53.52.6.6,0,0,0,.159.411.524.524,0,0,0,.371.129h2.147c.326,0,.5-.18.509-.54Zm7.948,9.411a1.6,1.6,0,0,1-.521,1.194,1.773,1.773,0,0,1-1.329.478H65.764a1.787,1.787,0,0,1-1.223-.488A1.722,1.722,0,0,1,64,112.722v-2.9a1.737,1.737,0,0,1,.436-1.2,1.774,1.774,0,0,1,1.391-.488h15.6a1.6,1.6,0,0,1,1.763,1.67v3.1h0Zm-8.011-1.538a.529.529,0,0,0-.138-.369.478.478,0,0,0-.373-.151H72.523a.52.52,0,1,0,0,1.04h2.145a.481.481,0,0,0,.373-.151A.523.523,0,0,0,75.179,111.356Z" transform="translate(-64 -96)" fill="var(--theme-color-1)"/>
  </svg>`,
  gongye: `
  <svg xmlns="http://www.w3.org/2000/svg" width="18.542" height="15.519" viewBox="0 0 18.542 15.519">
    <g transform="translate(-161.481 -310.125)">
      <path d="M-1968.811-6689.423h10.153v15.519h-10.153Z" transform="translate(2130.292 6999.548)" fill="var(--theme-color-1)"/>
      <path d="M-1968.811-6689.423l7.632,2.55v7.878h-7.632Z" transform="translate(2141.202 7004.639)" fill="var(--theme-color-1)"/>
      <g transform="translate(164.14 314.564)">
        <rect width="4.533" height="0.756" transform="translate(0 0)" fill="var(--theme-color-1)"/>
        <rect width="4.533" height="0.756" transform="translate(0 3.022)" fill="var(--theme-color-1)"/>
      </g>
    </g>
  </svg>`,
  userSum: `
  <svg xmlns="http://www.w3.org/2000/svg" width="18.9" height="18.39" viewBox="0 0 18.9 18.39">
    <path d="M15.832,18.368a.534.534,0,0,0,.515-.542l0-.19h.009c.007-.138.011-.259.011-.376a7.9,7.9,0,0,0-4.743-7.366L11.3,9.758l.286-.2a5.291,5.291,0,0,0,2.2-4.339A5.093,5.093,0,0,0,8.845,0,5.093,5.093,0,0,0,3.9,5.218,5.291,5.291,0,0,0,6.1,9.558l.286.2-.324.136a7.9,7.9,0,0,0-4.741,7.366c0,.117,0,.235.011.376h.013l0,.194a.54.54,0,0,0,.517.559c.286,0,13.684-.022,13.966-.022M14.56,10.231a4.981,4.981,0,0,1,3.308,1.842,6.079,6.079,0,0,1,1.3,3.823.551.551,0,0,0,.528.57.544.544,0,0,0,.524-.546l0-.017a.013.013,0,0,1,0-.009,6.574,6.574,0,0,0-3.949-6.125l-.324-.136.286-.2a4.389,4.389,0,0,0,1.833-3.6,4.268,4.268,0,0,0-3.128-4.2l-.011,0-.051,0a.176.176,0,0,1-.033,0l-.013,0A.559.559,0,0,0,14.3,2.2a.561.561,0,0,0,.455.57l.024,0,.022.009a.966.966,0,0,0,.113.037.092.092,0,0,1,.022.006h0a3.122,3.122,0,0,1,2.026,2.962,3.1,3.1,0,0,1-2.409,3.07l-.022.013-.047,0a.677.677,0,0,0,.016,1.345l.044,0,.02.013h0m0,0" transform="translate(-1.322)" fill="var(--theme-color-1)"/>
  </svg>`,
  demandLocation: `
  <svg xmlns="http://www.w3.org/2000/svg" width="17.803" height="21.489" viewBox="0 0 17.803 21.489">
    <path d="M113.734,38.593a8.9,8.9,0,1,1,12.588,0l-6.293,6.293-6.295-6.295Zm8.992-3.6a3.815,3.815,0,1,0-5.4,0A3.815,3.815,0,0,0,122.726,35Z" transform="translate(-111.126 -23.398)" fill="var(--theme-color-1)"/>
  </svg>`,
  demandType: `
  <svg xmlns="http://www.w3.org/2000/svg" width="18.037" height="18" viewBox="0 0 18.037 18">
    <path d="M68.241,1.763a1.142,1.142,0,0,1,.826.334,1.1,1.1,0,0,1,.343.816V7.552a1.172,1.172,0,0,1-1.169,1.169H63.6a1.1,1.1,0,0,1-.816-.343,1.142,1.142,0,0,1-.334-.826V2.913A1.141,1.141,0,0,1,63.6,1.763h4.639Zm0,9.278a1.142,1.142,0,0,1,.826.334,1.1,1.1,0,0,1,.343.816v4.658a1.1,1.1,0,0,1-.343.816,1.142,1.142,0,0,1-.826.334H63.6a1.141,1.141,0,0,1-1.15-1.151V12.192a1.141,1.141,0,0,1,1.15-1.15Zm9.3,0a1.141,1.141,0,0,1,1.15,1.15v4.658A1.141,1.141,0,0,1,77.537,18H72.9a1.142,1.142,0,0,1-.826-.334,1.1,1.1,0,0,1-.343-.816V12.192a1.1,1.1,0,0,1,.343-.816,1.142,1.142,0,0,1,.826-.334ZM80.117,3.8a1.194,1.194,0,0,1,.371.872,1.134,1.134,0,0,1-.371.854L76.665,8.981a1.189,1.189,0,0,1-1.726,0L71.488,5.53a1.163,1.163,0,0,1-.353-.854,1.225,1.225,0,0,1,.353-.872L74.94.353a1.232,1.232,0,0,1,1.726,0Z" transform="translate(-62.451)" fill="var(--theme-color-1)"/>
  </svg>`,
  demandDesc: `
  <svg xmlns="http://www.w3.org/2000/svg" width="17.79" height="17.688" viewBox="0 0 17.79 17.688">
    <path d="M13.394,9.406h-9.1a.806.806,0,0,1-.818-.818.88.88,0,0,1,.818-.818h9.1a.79.79,0,0,1,.818.716.9.9,0,0,1-.818.92Zm0,3.885h-9.1a.806.806,0,0,1-.818-.818.88.88,0,0,1,.818-.818h9.1a.806.806,0,0,1,.818.818A.752.752,0,0,1,13.394,13.291ZM3.476,4.805a.88.88,0,0,1,.818-.818H10.02a.769.769,0,0,1,.1,1.534H4.294A.725.725,0,0,1,3.476,4.805ZM16.154,0H1.636A1.6,1.6,0,0,0,0,1.534V16.154a1.532,1.532,0,0,0,1.636,1.534H16.154a1.6,1.6,0,0,0,1.636-1.534V1.534A1.746,1.746,0,0,0,16.154,0Z" fill="var(--theme-color-1)"/>
  </svg>`,
  demandName: `
  <svg id="xuqiumingcheng" xmlns="http://www.w3.org/2000/svg" width="18.997" height="18.506" viewBox="0 0 18.997 18.506">
    <path d="M69.718,422.937l.049.045,7.43,4.069a2.214,2.214,0,0,0,2.78,0l7.419-4.062.011-.007.049-.045a1.826,1.826,0,0,0,.211-2.539.106.106,0,0,0-.151-.015l-.725.59a.106.106,0,0,0-.015.151.675.675,0,0,1-.045.919L79.323,426.1l-.011.006-.049.045a1.048,1.048,0,0,1-1.351,0l-.049-.045-7.417-4.062a.675.675,0,0,1-.045-.919.108.108,0,0,0-.015-.151l-.725-.59a.108.108,0,0,0-.151.015A1.822,1.822,0,0,0,69.718,422.937Z" transform="translate(-69.089 -413.055)" fill="var(--theme-color-1)"/>
    <path d="M87.638,92.272l-.725.59a.106.106,0,0,0-.015.151.675.675,0,0,1-.045.919l-7.408,4.056-.011.006-.049.045a1.048,1.048,0,0,1-1.351,0l-.049-.045-7.417-4.062a.675.675,0,0,1-.045-.919.108.108,0,0,0-.015-.151l-.725-.59a.108.108,0,0,0-.151.015,1.826,1.826,0,0,0,.211,2.539l.049.045,7.43,4.069a2.214,2.214,0,0,0,2.78,0l7.419-4.062.011-.006.049-.045a1.826,1.826,0,0,0,.211-2.539A.109.109,0,0,0,87.638,92.272ZM70.222,87.2l1.173.641,6.253,3.423a1.621,1.621,0,0,0,2.122,0l6.253-3.423,1.173-.641a1.309,1.309,0,0,0,.151-.159,1.25,1.25,0,0,0-.151-1.749L79.769,81.32a1.621,1.621,0,0,0-2.122,0l-7.425,3.972a1.252,1.252,0,0,0-.151,1.749A1.5,1.5,0,0,0,70.222,87.2Z" transform="translate(-69.211 -80.925)" fill="var(--theme-color-1)"/>
  </svg>`,
  time: `
  <svg xmlns="http://www.w3.org/2000/svg" width="18.011" height="18.011" viewBox="0 0 18.011 18.011">
    <path d="M73.005,64a9.005,9.005,0,1,0,9.005,9.005A9.011,9.011,0,0,0,73.005,64Zm3.843,12.141-4.31-2.493h-.177V67.859h1.286v4.953l3.843,2.219Z" transform="translate(-64 -64)" fill="var(--theme-color-1)"/>
  </svg>`
};

export const getOverviewData = (
  data: typeof _testOverviewData & { [key: string]: any },
  isV2: boolean,
  is6: boolean,
  is21: boolean
) => {
  let res: Array<{
    icon: string;
    name?: string;
    value: string | number;
    hide?: boolean;
  }> = [
    {
      icon: svg.gongye,
      name: '项目方',
      value: data.gongyeName.replace(/^项目方：/, ''),
      hide: !data.gongyeName
    },
    {
      icon: svg.asp,
      name: data.nameShowType == 2 ? '项目方' : '服务商',
      value: data.aspName.replace(/^(项目方|服务商)：/, ''),
      hide: !data.aspName
    },
    { icon: svg.price, name: '订单金额', value: data.price },
    { icon: svg.demandName, name: '需求名称', value: data.demandName },
    {
      icon: svg.demandLocation,
      name: '需求地点',
      value: data.demandLocation
    },
    { icon: svg.time, name: '执行日期', value: data.executeTime },
    { icon: svg.demandDesc, name: '需求描述', value: data.demandDesc },
    {
      icon: svg.userSum,
      name: '项目执行人数',
      value: `${data.userSum}人`,
      hide: +data.isShowUserSum !== 1
    },
    { icon: svg.dataSum, name: '数据收集数量', value: `${data.dataSum}条` },
    { icon: svg.time, name: '数据提交时间', value: data.submitTime }
  ];
  if (isV2) {
    res = [
      {
        icon: svg.gongye,
        name: '项目方',
        value: data.gongyeName.replace(/^项目方：/, ''),
        hide: !data.gongyeName
      },
      {
        icon: svg.asp,
        name: data.nameShowType == 2 ? '项目方' : '服务商',
        value: data.aspName.replace(/^(项目方|服务商)：/, ''),
        hide: !data.aspName
      },
      { icon: svg.demandName, name: '需求名称', value: data.demandName },
      {
        icon: svg.dataSum,
        name: '本期个人数据数',
        value: data.executePeopleNumber,
        hide: !data.executePeopleNumber
      },
      {
        icon: svg.dataSum,
        name: '累计个人数据总数',
        value: ` ${data.taskSum}条`,
        hide: !data.taskSum
      },
      {
        icon: svg.time,
        name: '任务开始时间',
        value: data.taskStartTime,
        hide: !is6 || !data.taskStartTime
      },
      {
        icon: svg.time,
        name: '任务结算时间',
        value: data.taskEndTime,
        hide: !is6 || !data.taskEndTime
      },
      {
        icon: svg.time,
        name: '报表生成时间',
        value: data.createDt,
        hide: !is21
      },
      {
        icon: svg.dataSum,
        name: '本期个人数据数',
        value: data.executePeopleNumber,
        hide: !data.executePeopleNumber
      },
      {
        icon: svg.time,
        name: '任务时间',
        value: `${data.taskTime}天`,
        hide: !is6 || !data.taskTime
      },
      {
        icon: svg.time,
        name: '报表生成时间',
        value: data.createDt,
        hide: !is6
      }
    ];
  }
  return res.filter(i => !i.hide);
};
